import { NgModule } from '@angular/core';
import { OiRatingBarComponent } from './oi-rating-bar.component';



@NgModule({
  declarations: [OiRatingBarComponent],
  imports: [
  ],
  exports: [OiRatingBarComponent]
})
export class OiRatingBarModule { }
